interface ExpertApplication {
  id: string;
  user_id: string | null;
  full_name: string;
  email: string;
  phone: string | null;
  professional_title: string;
  years_experience: number;
  specializations: string[];
  bio: string;
  hourly_rate: number;
  linkedin_url: string | null;
  website_url: string | null;
  motivation_letter: string | null;
  profile_image_url: string | null;
  availability_hours: string | null;
  preferred_meeting_types: string[] | null;
  certifications: string[] | null;
  cv_file_url: string | null;
  package_pricing: any | null;
  status: 'pending' | 'approved' | 'rejected';
  admin_notes: string | null;
  reviewed_by: string | null;
  reviewed_at: string | null;
  created_at: string;
  updated_at: string;
}

interface PublishedExpert {
  id: string;
  application_id: string;
  status: 'active' | 'inactive' | 'draft' | 'pending_approval' | 'suspended';
  full_name: string;
  professional_title: string;
  bio: string;
  years_experience: number;
  specializations: string[];
  hourly_rate: number;
  admin_notes: string | null;
  approved_by: string | null;
  approved_at: string | null;
  created_at: string;
  updated_at: string;
}

export function useExpertApplicationsFiltering(
  applications: ExpertApplication[],
  publishedExperts: PublishedExpert[]
) {
  const getFilteredApplications = (activeTab: string) => {
    // console.log("🔍 Filtering applications for tab:", activeTab);
    // console.log("📊 All applications:", applications);
    // console.log("📋 Applications by status:", applications.reduce((acc, app) => {
    
    if (activeTab === "published") {
      const publishedApplications = publishedExperts
        .filter(expert => expert.status === 'active')
        .map(expert => {
          const originalApp = applications.find(app => app.id === expert.application_id);
          if (originalApp) {
            return originalApp;
          }
          
          return {
            id: expert.application_id,
            user_id: null,
            full_name: expert.full_name,
            email: '',
            phone: null,
            professional_title: expert.professional_title,
            years_experience: expert.years_experience || 0,
            specializations: expert.specializations || [],
            bio: expert.bio || '',
            hourly_rate: expert.hourly_rate || 0,
            linkedin_url: null,
            website_url: null,
            motivation_letter: null,
            profile_image_url: null,
            availability_hours: null,
            preferred_meeting_types: null,
            certifications: null,
            cv_file_url: null,
            package_pricing: null,
            status: 'approved' as const,
            admin_notes: expert.admin_notes,
            reviewed_by: expert.approved_by,
            reviewed_at: expert.approved_at,
            created_at: expert.created_at,
            updated_at: expert.updated_at,
          };
        });
      
      // console.log("✅ Published applications found:", publishedApplications.length);
      return publishedApplications;
    }
    
    const filtered = applications.filter(app => {
      // console.log(`🔍 Checking app ${app.id}: status = ${app.status}, activeTab = ${activeTab}`);
      return app.status === activeTab;
    });
    
    // console.log(`📋 ${activeTab} applications:`, filtered.length);
    return filtered;
  };

  const getStatusCount = (status: string) => {
    if (status === "published") {
      const count = publishedExperts.filter(expert => expert.status === 'active').length;
      // console.log("📊 Published count:", count);
      return count;
    }
    
    const count = applications.filter(app => app.status === status).length;
    // console.log(`📊 ${status} count:`, count);
    return count;
  };

  return {
    getFilteredApplications,
    getStatusCount
  };
}
